export interface IBankBranch {
  code: string;
  name: string;
  bankName: string;
}

export interface IBankBranches {
  bank_branches?: IBankBranch[];
}

export interface IOccupation {
  occupation_code: string;
  afrikaans: string;
  english: string;
}

export interface IOccupations {
  occupations: IOccupation[];
}

export interface IGeneralCodeDescriptionType {
  code: string;
  description: string;
}
